export const DATA_LOADED = 'DATA_LOADED';

export const QUERY_PARAM_LOADED = 'QUERY_PARAM_LOADED';

export const QUERY_PARAM_SORT = 'QUERY_PARAM_SORT';

export const VEHICLE_SELECTED = 'VEHICLE_SELECTED';

export const LEASE_FILTER = {
  FILTER_SELECTED: 'LEASE_FILTER_SELECTED',
  GET_LEASE_FILTER: 'GET_LEASE_FILTER',
};

export const ZIPCODE = {
  UPDATE: 'ZIPCODE.UPDATE',
};

export const SELECT_VEHICLE = 'SELECT_VEHICLE';

export const OFFER_DETAILS = {
  CLOSE: 'OFFER_DETAILS.CLOSE',
  OPEN: 'OFFER_DETAILS.OPEN',
};
